import React from "react";
import  { useState, useEffect } from 'react';
import './classes/AgencyMarketing.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";

const AgencyMarketing = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            
        ])
        .then(() => {
        setIsLoading(false);
        })
     
    },[]);

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main" className="agency-marketing-main">
                    <Helmet><title>How to market players to teams. How to market players to clubs, SMWW Sports Agency</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="agency-marketing-container">
                            <div>
                                <h1>Marketing Players to Teams &amp; Clubs&nbsp;the SMWW Way</h1>
                                <p>At SMWW Agency&nbsp;our philosophy is that you can't agent your way to the next level.&nbsp;&nbsp;You have to play your way to the next level. At SMWW, we&nbsp;have over&nbsp;40 years of experience marketing players to teams and clubs around the world in all sports.&nbsp; SMWW&nbsp;has worked long and hard to earn a great reputation in regards to talent identification.&nbsp;We are&nbsp;well known for our cutting edge scouting and player analysis training. In addition, we have trained hundreds of graduates who now&nbsp;scout players for the top teams and clubs&nbsp;at all levels. This includes&nbsp;of scouting,&nbsp;talent identification, and player analysis in all the major&nbsp;leagues.</p>
                                <p><img src="/basic/web/images/agent/pexels-photo-89699.jpeg" width="100%" /></p>
                                <h3>
                                    <span style={{color:"#003c7d"}}><strong>SMWW Agency develops dynamic marketing materials for each client</strong></span><br />
                                    &nbsp;
                                </h3>
                                <p>Most teams and clubs have&nbsp;their&nbsp;own scouting department. Therefore every player needs to be effectively marketed to teams to ensure that every opportunity is provided to improve their playing opportunities. SMWW Agent Advisors will articulate the unique characteristics of our clients to the appropriate teams in the appropriate way. Each team has its preferred nuances which can vary by season, player personnel, and team needs. To do so, SMWW will assess your game in order to effectively market your unique skill set to the right teams that match your abilities.<br />
                                Depending on a player's position, the team or club's needs, nuances, and player personnel, the following is an example that would be gathered and presented to teams:</p>
                                <div className="twocoll">
                                    <ul>
                                        <li>Scouting Report</li>
                                        <li>Player's Background</li>
                                        <li>Player's Career History</li>
                                        <li>Player's Strengths</li>
                                    </ul>
                                </div>
                                <div className="twocoll">
                                    <ul>
                                        <li>Player's Career Aspirations</li>
                                        <li>Professional References</li>
                                        <li>Physical Evidence of Success (Game Film / Press / Media)</li>
                                    </ul>
                                </div>
                                <div style={{clear:"both"}}>&nbsp;</div>
                                <div style={{clear:"both"}}>&nbsp;</div>
                                <div style={{clear:"both"}}>&nbsp;</div>
                                <div className="courseboxx">
                                    <h3>
                                        <img alt="&quot;" height="21" src="/basic/web/images/agent/new_quote-open.png" width="29" />
                                        <em>Dr. Lashbrook was with me through the Combine, the Draft, my career with 3 NFL teams, and we have remained close even today. He has helped me tremendously in getting my business up and running and I feel like I couldn't have done it without him. I really appreciate his loyalty, integrity, and passion for my welfare and for my family. He was there for me then and still is today. </em>
                                        <sub><img alt="&quot;" height="21" src="/basic/web/images/agent/new_quote-close.png" width="29" />&nbsp;</sub><br />
                                        <em><sub><span style={{fontWeight:"normal", lineHeight:"2em"}}>- Alex Van Dyke, former Philidelphia Eagles and New York Jets Wide Receiver</span></sub></em>
                                    </h3>
                                </div>
                            </div>
                        </div>  
                    </div>
                    <div className="right">
                        <SalespersonSidebar />
                    </div>
                </div>
            )}
        </>
    );
};
export default AgencyMarketing;